// extracted by mini-css-extract-plugin
module.exports = {"root":"WifiJourneys_root__2M0pK","edit_buttons":"WifiJourneys_edit_buttons__1uzqp"};